import { render, staticRenderFns } from "./WhatWeDo.vue?vue&type=template&id=486da630&"
import script from "./WhatWeDo.vue?vue&type=script&lang=js&"
export * from "./WhatWeDo.vue?vue&type=script&lang=js&"
import style0 from "./WhatWeDo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports